import { Button, Form, Input, message, Table } from "antd";
import React, { useEffect, useState } from "react";
import { EditOutlined } from "@ant-design/icons";
import { fetchHealthConditions } from "./FetchHealthCondition";
import { useSelector } from "react-redux";
import { selectBaseUrl, selectProdTestUrl } from "../../redux/slices/envSlice";
import { token } from "../../constants/Constants";
import { create_health_condition, update_health_condition } from "../../endpoints/API";

const HealthCondition = () => {
  const baseUrl = useSelector(selectBaseUrl);
  const prodTestUrl = useSelector(selectProdTestUrl);
  const [form] = Form.useForm();
  const [isEditMode, setIsEditMode] = useState(false);
  const [selectedCondition, setSelectedCondition] = useState(null);
  const [healthConditions, setHealthConditions] = useState([]);
  const user = useSelector((state) => state.user.user);

  useEffect(() => {
    const loadHealthConditions = async () => {
      try {
        await fetchHealthConditions(setHealthConditions, baseUrl, prodTestUrl);
      } catch (error) {
        message.error(error?.response?.data?.error||"Failed to fetch health conditions.");
      }
    };

    loadHealthConditions();
  }, []);

  const handleSaveOrUpdate = async (values) => {
    const payload = {
      title: values.title,
      user_id: user.user_id, 
      id: isEditMode && selectedCondition ? selectedCondition.id : undefined, 
    };

    try {
      let response;

      if (isEditMode && selectedCondition) {
        response = await update_health_condition(payload);
      } else {
        response = await create_health_condition(payload);
      }

      if (response.statusText=="OK") {
        const data = response?.data;
        message.success(
          `Health Condition ${isEditMode ? "updated" : "added"} successfully!`
        );
        form.resetFields();
        await fetchHealthConditions(setHealthConditions, baseUrl, prodTestUrl); // Reload health conditions
        setIsEditMode(false);
        setSelectedCondition(null);
      } else {
        const errorResponse = response?.data;
        message.error(
          errorResponse.error || "Failed to save the health condition."
        );
      }
    } catch (error) {
      message.error(error?.response?.data?.error||"An error occurred. Please try again later.");
    }
  };

  const handleEdit = (record) => {
    form.setFieldsValue({ title: record.title });
    setSelectedCondition(record);
    setIsEditMode(true);
  };

  const columns = [
    {
      title: "Health Condition",
      dataIndex: "title",
      key: "title",
    },
    {
      title: "Edit",
      key: "edit",
      render: (text, record) => (
        <Button onClick={() => handleEdit(record)}>
          <EditOutlined />
        </Button>
      ),
    },
  ];

  return (
    <div>
      <Form form={form} onFinish={handleSaveOrUpdate}>
        <div
          className="border flex gap-5 p-4 items-center rounded-lg shadow-md"
          style={{ padding: "16px" }}
        >
          <Form.Item
            label={<span className="font-semibold">Health Condition</span>}
            name="title"
            rules={[
              { required: true, message: "Please enter a health condition!" },
            ]}
            style={{ margin: "0" }}
          >
            <Input
              placeholder="Enter health condition"
              style={{ width: "100%" }}
            />
          </Form.Item>

          <Form.Item style={{ margin: "0" }}>
            <Button type="primary" htmlType="submit">
              {isEditMode ? "Update" : "Save"}
            </Button>
          </Form.Item>
        </div>
      </Form>
      <Table dataSource={healthConditions} columns={columns} rowKey="id" />
    </div>
  );
};

export default HealthCondition;
